import { api } from "../api";

export async function fetchUserOrders() {
  try {
    const { data } = await api.get("/orders");
    return data.data || [];
  } catch (err) {
    throw new Error("Erro ao buscar pedidos: " + err.message);
  }
}

// Busca detalhes de um pedido específico
// Tenta múltiplas rotas conhecidas para maior compatibilidade
export async function fetchOrderDetail(orderId) {
  if (!orderId) throw new Error("orderId é obrigatório");
  const tryEndpoints = [
    { url: `/orders/${orderId}` },
    { url: "/getOrderDetail", params: { ord_id: orderId } },
    { url: "/order/detail", params: { ord_id: orderId } },
    { url: "/orderDetail", params: { orderId } },
  ];

  for (const ep of tryEndpoints) {
    try {
      const { data } = await api.get(ep.url, { params: ep.params });
      if (data) return normalizeOrderDetail(data);
    } catch (e) {
      // tenta próximo endpoint
    }
  }
  // Fallback: busca a lista inteira e seleciona o pedido
  try {
    const list = await fetchUserOrders();
    const found = (list || []).find(
      (o) => String(o?.ord_id) === String(orderId),
    );
    return normalizeOrderDetail(found || {});
  } catch (e) {
    throw new Error("Não foi possível obter detalhes do pedido");
  }
}

// Normaliza possíveis formatos para um shape único utilizado na página
function normalizeOrderDetail(raw = {}) {
  if (!raw) raw = {};
  const base = raw.data || raw.order || raw;
  const shipping = base.shipping || base.ord_shipping || {};
  const billing = base.billing || base.ord_billing || {};

  const trackingCode =
    base.tracking_code ||
    base.ord_shipping_tracking_code ||
    base.ord_shipping_shipment_id ||
    shipping?.tracking_code ||
    null;

  const trackingUrl = base.tracking_url || shipping?.tracking_url || null;

  const invoiceUrl = base.invoice_url || base.nfe_url || base.nfe_link || null;

  return {
    ord_id: base.ord_id || base.id || null,
    code: base.ord_code || base.code || null,
    created_at: base.created_at || base.date || null,
    status: base.ord_status || base.status || null,
    fulfillment_status:
      base.ord_fulfillment_status || base.fulfillment_status || null,
    total: base.ord_total || base.total || 0,
    items: base.items || [],

    tracking_code: trackingCode,
    tracking_url: trackingUrl,
    invoice_url: invoiceUrl,

    shipping_address: shipping.address || base.shipping_address || null,
    billing_address: billing.address || base.billing_address || null,
    shipping_method_label:
      base.shipping_method_label ||
      shipping.method_label ||
      base.ord_shipping_method_label ||
      null,

    payment_method_label:
      base.payment_method_label || base.ord_payment_method || null,
    payment_installments:
      base.payment_installments || base.ord_installments || null,

    pagseguro_order_id:
      base.pagseguro_order_id ||
      base.ps_order_id ||
      base.ord_ps_order_id ||
      null,
    pagseguro_transaction_id:
      base.pagseguro_transaction_id ||
      base.ps_transaction_id ||
      base.ord_ps_transaction_id ||
      null,
    reference_id: base.reference_id || base.ord_reference_id || null,

    timeline: base.timeline || base.events || [],
  };
}

export async function fetchOrderTracking(orderId) {
  if (!orderId) throw new Error("orderId é obrigatório");
  try {
    const { data } = await api.get(`/orders/${orderId}/tracking`);
    return data.data || null;
  } catch (err) {
    throw new Error("Erro ao buscar rastreio: " + err.message);
  }
}
